import { useParams, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useMyQuery } from '@hooks/useMyQuery';
import { useStore } from '@hooks/useStore';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { AppLoader } from '@components/Core/AppLoader';
import { PageHeader } from '@components/Core/PageHeader';
import PointForm from '@forms/PointForm';
import { StatusType } from '@/types/common';
import { EditPointTransFields } from './types';
import { editPointTranslations } from './translations';

function EditPoint() {
  const {
    brandsStore: { brand },
    pointsStore: { getPoint, point },
  } = useStore();

  const { t } = useMyTranslations<EditPointTransFields>([editPointTranslations.name]);

  const { pointId } = useParams();
  const [params, _] = useSearchParams();

  const { isFetching, text } = useGetBrandData(t('edit point'));

  const { isFetching: isFetchingPoint } = useMyQuery({
    queryKey: ['getPoint'],
    queryFn: () => {
      const status = params.get('status') as StatusType;
      if (pointId && status) return getPoint({ id: pointId, status });
      else return null;
    },
    enabled: !!pointId && !!params.get('status'),
    staleTime: 0,
  });

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {(isFetching || isFetchingPoint) && <AppLoader />}
      {!isFetching && !isFetchingPoint && brand && point && (
        <PointForm brandId={brand.id} point={point} />
      )}
    </div>
  );
}

export default observer(EditPoint);
